import { useCurrentUser } from '@mp/hooks';
import React, { useEffect, useRef } from 'react';
import calendlyWidget from '@mp/utils/calendlyWidget';
import { config } from '@mp/config';
import { useCalendlySchedulingMutations } from './mutations';

const schedulingCompleted = (e: MessageEvent) =>
  e.origin === 'https://calendly.com' && e.data.event === 'calendly.event_scheduled';

export const PhoneScreeningSchedulerForm = () => {
  const { currentUser } = useCurrentUser();
  const { schedulingCompletedMutation } = useCalendlySchedulingMutations();
  const calendlyURL = config.calendlyAssignmentURL;
  const name = `${currentUser?.first_name || ''} ${currentUser?.last_name || ''}`;
  const email = currentUser?.email || '';
  const a1 = currentUser?.phone_number || '';
  const processedEventRef = useRef(null);

  useEffect(() => {
    calendlyWidget();
  }, []);

  useEffect(() => {
    const handleMessage = (e: MessageEvent) => {
      if (schedulingCompleted(e)) {
        if (processedEventRef.current === e.data.payload.event.uri) {
          return;
        }
        processedEventRef.current = e.data.payload.event.uri;
        const payload = {
          professional_screening: {
            calendly_scheduled_event_uri: e.data.payload.event.uri,
            calendly_scheduled_event_invitee_uri: e.data.payload.invitee.uri,
            reason: 're_screening',
            screening_type: 'phone',
          },
        };
        schedulingCompletedMutation(payload);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [schedulingCompletedMutation]);

  return (
    <div
      className="calendly-inline-widget"
      data-url={`${calendlyURL}?name=${name}&email=${email}&a1=${a1}`}
      style={{ height: 650 }}
    />
  );
};
